import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IPBSDetailedPayableView from './IPBSDetailedPayableView';

const IPBSDetailedPayableModal = ({ selectedPayable, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Payable Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <IPBSDetailedPayableView selectedPayable={selectedPayable} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

IPBSDetailedPayableModal.propTypes = {
  selectedPayable: PropTypes.instanceOf(Object).isRequired,
};

export default IPBSDetailedPayableModal;
